// extracted by mini-css-extract-plugin
export default {"app":"start_app__5ldwy"};